import React, {useEffect, useState, useRef} from "react";
import merchant from "../../network/services/merchant";
import {getCourierBusinessId} from "../../helpers/authenticator";
import Loader from "react-loaders";
import {dateFormatter, setDataTables} from "../../helpers/general_helper";


const RidersTable = () => {
    const [riders, setRiders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const t = useRef("");

    useEffect(() => {
        merchant.getCourierBusinessRiders(getCourierBusinessId()).then(response => {
            setRiders(response.data.data);
            setIsLoading(false);
            setDataTables();
        }).catch(error => {
            setIsLoading(false);
        });

    }, []);


    return (
        <>
            {
                isLoading ? <Loader type="ball-scale-multiple"/> : <div className="col-md-10 card">
                    <div className="table-responsive">
                        <table ref={t} className="table table-borderless">
                            <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Added</th>
                                <th scope="col">Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {riders.map((rider, index) => {
                                return (<tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        <a href={"/rider/" + rider.phone}>
                                            {rider.name}
                                        </a>
                                    </td>
                                    <td>
                                        <a href={"/rider/" + rider.phone}>
                                            {rider.phone}
                                        </a>
                                    </td>
                                    <td>
                                        {dateFormatter(rider.created_at)}
                                    </td>
                                    <td>
                                <span
                                    className="badge badge-pill badge-primary">
                                    {rider.status === "1" ? "Active" : "Inactive"}
                                </span>
                                    </td>
                                </tr>)
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }

        </>
    );
};

export default RidersTable;
